import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=7bdfd409"
import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports